export const DefaultRequiredFields = {
    Name: true,
    Surname: true,
    Telephone: true,
    Homephone: true,
    Cellphone: true,
    Email: true,
    StreetAddress: true,
    StreetSuburb: true,
    StreetCity: true,
    StreetProvince: true,
    StreetCountry: true,
    StreetCode: true,
    PostalAddress: true,
    PostalSuburb: true,
    PostalCity: true,
    PostalProvince: true,
    PostalCountry: true,
    PostalCode: true,
    Organisation: true,
    Designation: true,
    ProfessionalBodyRegNum: true,
    ProfessionalBody: true,
};
